import dayjs from 'dayjs';

import {
  SearchType,
  type OperationsFilters,
  type Pagination,
} from '@app/pages/Warehouses/WarehouseOperations/types';

export const PF = 'warehouse-operations';

export const initialFilters: OperationsFilters = {
  SearchTerm: '',
  range: [dayjs().subtract(6, 'day'), dayjs()],
  warehouses: [],
  operationTypes: [],
  products: [],
  SearchBy: SearchType.Products,
};

export const initPagination: Pagination = {
  ItemsPerPage: 20,
  Page: 1,
  Total: 0,
};

export const searchTypeOptions = [
  { label: 'Товары', value: SearchType.Products },
  { label: 'Поставщики', value: SearchType.Suppliers },
];
